import { inject } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {AuthenticationService} from "../../authentication/authentication.service";

export const AuthGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) =>  {

    const router = inject(Router);
    const authService = inject(AuthenticationService);

    if (authService.currentUser() != null) {
        // logged in so return true
        return true;
    }

    // not logged in so redirect to login page
    router.navigate(['/login']);
    return false;
}
